import {hasAccessProtectionCookie, hasMoManAccessProtectionCookie, setCookie} from '../Utility/CookieUtility';
import GLightbox from 'glightbox';
import { SlimSelectController } from '../Controllers/SlimSelectController';

export function initAccessProtection(scope: Document | HTMLElement = document) {
  initAccessProtectionHandler();
  checkProtectedElements();
}

function initAccessProtectionHandler() {
  const protectedElements: NodeListOf<HTMLLinkElement> = document.querySelectorAll('[data-protected="1"]');
  protectedElements.forEach((element) => {
    element.addEventListener('click', (e) => {
      if (!(element instanceof HTMLElement)) {
        return;
      }
      const type = element.dataset.type || '';
      if (type === 'video') {
        return;
      }
      e.preventDefault();

      if (element.dataset.leadsource === 'MoMan') {
        if (hasMoManAccessProtectionCookie()) {
          openLink(element, type);
        } else {
          buildAccessProtectionForm(element);
        }
      } else {
        if (hasAccessProtectionCookie()) {
          openLink(element, type);
        } else {
          buildAccessProtectionForm(element);
        }
      }
      return false;
    });
  });
}

export async function buildAccessProtectionForm(element: HTMLElement | null) {
  await accessProtectionPartialHandler(element);
  if (!(element instanceof HTMLElement)) {
    return;
  }
  let accessProtectionForm = document.querySelector('.js-accessProtectionWrapper');
  if (element.dataset.leadsource === 'MoMan') {
    accessProtectionForm = document.querySelector('.js-accessProtectionWrapperMoMan');
  }
  if (!(accessProtectionForm instanceof HTMLElement)) {
    return;
  }

  const accessProtectionLightbox = new GLightbox({
    skin: 'clean glightbox--accessProtection js-lightboxAccessProtection',
    width: 'inital',
    height: 'inital',
    touchNavigation: false,
    draggable: false,
    elements: [
      {
        content: accessProtectionForm.innerHTML,
      },
    ],
  });
  accessProtectionLightbox.open();

  /* Initialize selects in the lightbox */
  new SlimSelectController('.js-lightboxAccessProtection .js-lightboxSelect');

  const lightBox = document.querySelector('.js-lightboxAccessProtection .accessProtection');
  const form = document.querySelector('.js-lightboxAccessProtection form');
  if (form) {
    const apTitleInput: HTMLInputElement | null = form?.querySelector('.js-accessProtectionApTitle');
    const apTitleType: HTMLInputElement | null = form?.querySelector('.js-accessProtectionApType');
    if (apTitleInput) {
      apTitleInput.value = element.dataset.aptitle || '';
    }
    if (apTitleType) {
      apTitleType.value = element.dataset.aptype || '';
    }
    fetchCaptchaImage();
  }

  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  const submitButtonElement: HTMLInputElement | null = form.querySelector('input[type="submit"]');
  submitButtonElement?.addEventListener('click', () => {
    if (form) {
      const requiredElems: NodeListOf<HTMLInputElement> = form.querySelectorAll('input[required], select[required]');
      for (let i = 0; i < requiredElems.length; i++) {
        requiredElems[i].classList.add('showValidity');
      }
    }
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const actionUrl = form.action;
    const formData = new FormData(form);
    const formNamePrefix = 'tx_ausproject_accessprotection[formData]';
    const targetUrl = location.href.split('#')[0] + ('#' + element.closest('[id]')?.id || '');
    const data = {
      firstname: formData.get(`${formNamePrefix}[access_firstname]`),
      lastname: formData.get(`${formNamePrefix}[access_lastname]`),
      company: formData.get(`${formNamePrefix}[access_company]`),
      email: formData.get(`${formNamePrefix}[access_email]`),
      zip: formData.get(`${formNamePrefix}[access_zip]`),
      country: formData.get(`${formNamePrefix}[access_country]`),
      targetUrl,
      type: element.dataset.type || '',
      qualificationStatus: formData.get(`${formNamePrefix}[qualificationStatus]`),
      salesTeam: formData.get(`${formNamePrefix}[salesTeam]`),
      salutation: formData.get(`${formNamePrefix}[salutation]`),
      lang: formData.get(`${formNamePrefix}[lang]`),
      form: formData.get(`${formNamePrefix}[form]`),
      LeadSource: formData.get(`${formNamePrefix}[LeadSource]`),
      AP_Title: formData.get(`${formNamePrefix}[AP_Title]`),
      AP_URL: formData.get(`${formNamePrefix}[AP_URL]`),
      AP_Type: formData.get(`${formNamePrefix}[AP_Type]`),
      captcha: formData.get(`${formNamePrefix}[captcha]`),
      captchaResult: formData.get('tx_ausproject_newsletter[formData][captchaResult]'),
    };
    sendRequest(actionUrl, data)
      .then((result) => {
        if (!result.isValid) {
          form.querySelector('.js-captcha-error')?.classList.remove('hide');
          return;
        }

        if (!result.isMoMan) {
          const successContent = document.querySelector('.js-lightboxAccessProtection .js-accessProtectionSuccess');
          const formContent = document.querySelector('.js-lightboxAccessProtection .js-accessProtectionForm');
          if (successContent && formContent) {
            successContent.classList.add('slideIn');
            formContent.classList.add('slideOut');

            if (lightBox) {
              lightBox.scrollTo(0, 0);
            }
          }
          checkProtectedElements();
        } else {
          accessProtectionLightbox.close();
          openLink(element, element.dataset.type || '');
        }
      })
      .catch((error) => {
        /* temporarily display error for dev debugging */
        console.error('error: ', error);
      });
  });
}

/* @todo: move to utility? */
async function sendRequest(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
}

function openLink(element: HTMLElement, type: string) {
  const link = document.createElement('a');
  const source = element.dataset.source || '';

  if (source === '') {
    return;
  }

  link.href = source;
  link.target = type === 'pdf' ? '_blank' : element.getAttribute('target') || '';
  link.click();
}

function checkProtectedElements() {
  const protectedElements: NodeListOf<HTMLElement> | null = document.querySelectorAll('[data-protected="1"]');

  protectedElements.forEach((protectedElement) => {
    if (protectedElement.dataset.leadsource === 'MoMan') {
      if (hasMoManAccessProtectionCookie()) {
        hideProtectionIcon(protectedElement);
      }
    } else {
      if (hasAccessProtectionCookie()) {
        hideProtectionIcon(protectedElement);
      }
    }
    // remove href from links (external and files) and save them in data-source
    if (protectedElement.dataset.type === 'link' || protectedElement.dataset.type === 'file' || protectedElement.dataset.type === 'page') {
      const linkElement: HTMLLinkElement = <HTMLLinkElement>protectedElement;
      linkElement.dataset.source = linkElement.href;
      linkElement.href = 'javascript:void(0)';
    }
  });
}

function hideProtectionIcon(protectedElement) {
  const lockElement: HTMLElement | null = protectedElement.querySelector('.js-accessProtectionLock');
  if (lockElement) {
    lockElement.classList.add('hide');
  }
}

function initCaptchaReload() {
  const form = document.querySelector('.js-lightboxAccessProtection form');
  if (!form) {
    return;
  }
  const captchaReloadElement = form.querySelector('.js-captcha-reload-newsletter');
  if (captchaReloadElement) {
    captchaReloadElement.addEventListener('click', async (e) => {
      e.preventDefault();
      await fetchCaptchaImage();
    });
  }
}

async function fetchCaptchaImage() {
  const form = document.querySelector('.js-lightboxAccessProtection form');
  if (!form) {
    return;
  }
  const captchaImageElement: HTMLInputElement | null = form.querySelector('.js-captchaImage');
  if (captchaImageElement) {
    const captchaImageGenerationUrl = captchaImageElement.dataset.url || '';
    fetch(captchaImageGenerationUrl)
      .then(response => response.text())
      .then((image) => {
        captchaImageElement.innerHTML = image;
        initCaptchaReload();
      });
  }
}

async function accessProtectionPartialHandler(element: HTMLElement | null) {
  if (document.querySelectorAll('.js-accessProtectionWrapper').length === 0 &&
    document.querySelectorAll('.js-accessProtectionWrapperMoMan').length === 0) {
    const accessProtectionPlaceholder = document.querySelector('.js-accessProtectionPlaceholder');
    if (accessProtectionPlaceholder) {
      let url = window.location.pathname.substring(0, 3) + '/?type=1665105482';
      if (window.location.host.startsWith('cn.') || window.location.host.endsWith('.cn')) {
        url = '/?type=1665105482';
      }
      fetch(url)
        .then(response => response.text())
        .then((accessProtectionFormHtml) => {
          accessProtectionPlaceholder.outerHTML = accessProtectionFormHtml;
          buildAccessProtectionForm(element);
        });
    }
  }
}

